var map = {
	"./costume_1.svg": 2553,
	"./costume_2.svg": 9166,
	"./costume_3.svg": 689,
	"./costume_4.svg": 4004,
	"./costume_5.svg": 2139,
	"./costume_6.svg": 4094,
	"./costume_7.svg": 3861
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2525;